// PageDescription: 비대면진료 웹 진료 신청 페이지
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import useAuth from '@/hooks/auth/useAuth';
import { CustomPageProps } from '@/types/app';
import { TelemedicineRequestView } from '@/views/telemedicine/request';

const TelemedicineRequestPage = ({ client }: CustomPageProps) => {
  const router = useRouter();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const { token } = useAuth();

  useEffect(() => {
    if (!token) {
      router.push('/');
    } else {
      setIsAuthenticated(true);
    }
    setIsChecking(false);
  }, [router, token]);

  if (isChecking) {
    return null;
  }

  if (!isAuthenticated) {
    return null;
  }

  return <TelemedicineRequestView client={client} />;
};

export default TelemedicineRequestPage;
